import {
  ADD_ANSWER_TO_CURRENT_ATTEMPT,
  INIT_QUIZ_ATTEMPT,
  SEND_QUIZ_ANSWER_ERROR,
  SEND_QUIZ_ANSWER_REQUEST,
  SENT_QUIZ_ANSWER_OK,
  SET_CURRENT_QUESTION,
} from 'redux/constants/ActionTypes'

import { createApiAction } from './ApiActions'

// API actions
export const sendQuizAnswer = (quizId, newAnswer, attempt) => {
  const { question, answer, order, result } = newAnswer

  return createApiAction({
    endpoint: `/quizzes/${quizId}/answers/`,
    types: [
      SEND_QUIZ_ANSWER_REQUEST,
      SENT_QUIZ_ANSWER_OK,
      SEND_QUIZ_ANSWER_ERROR,
    ],
    method: 'POST',
    data: {
      question,
      answer,
      order,
      result,
      attempt,
    },
    options: {
      parseResponse: true,
    },
  })
}

// Standard actions
export const initQuizAttempt = ({
  currentLocale,
  quizLength,
  quizVersion,
  userId = null,
  sessionId = null,
}) => {
  return {
    type: INIT_QUIZ_ATTEMPT,
    currentLocale,
    quizLength,
    quizVersion,
    userId,
    sessionId,
  }
}

export const addAnswerToCurrentAttempt = (
  { question, answer, result },
  attempt
) => {
  return {
    type: ADD_ANSWER_TO_CURRENT_ATTEMPT,
    question,
    answer,
    result,
    attempt,
  }
}

export const setCurrentQuestion = (questionNumber) => {
  return {
    type: SET_CURRENT_QUESTION,
    questionNumber,
  }
}
